import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import {
  AccountSummary,
  AccountSummaryState,
  FetchAccountSummaryResult,
} from "./accountSummary-state";
import { defaultGenericMeta, FilterProps } from "store/common";
import { fetchAccountSummary } from "./accountSummary-action";

const accountSummaryEntityAdapter = createEntityAdapter<AccountSummary>({});

export const accountSummarySlice = createSlice({
  name: "accountsummary",
  initialState:
    accountSummaryEntityAdapter.getInitialState<AccountSummaryState>({
      meta: { ...defaultGenericMeta },
    }),
  reducers: {
    setFilters(state, action: PayloadAction<FilterProps>) {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    clearFilter(state) {
      state.filters = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchAccountSummary.fulfilled,
      (state, action: PayloadAction<FetchAccountSummaryResult>) => {
        state.meta.isLoading = false;
        state.meta.isSuccess = true;
        state.meta.status = "idle";
        const { results, ...serviceMeta } = action.payload;
        accountSummaryEntityAdapter.setAll(state, results);
        state.serviceMeta = serviceMeta;
      }
    );
    builder.addCase(fetchAccountSummary.pending, (state) => {
      state.meta.isLoading = true;
      state.meta.status = "inProcess";
    });
    builder.addCase(fetchAccountSummary.rejected, (state) => {
      state.meta.isLoading = false;
      state.meta.status = "idle";
      state.meta.error = "true";
    });
  },
});

export const { setFilters, clearFilter } = accountSummarySlice.actions;
export default accountSummarySlice.reducer;
